import { Theme, styled } from "@mui/material";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";

import React from "react";
import { paletteColors } from "../../../styles/muiTheme";

export const CustomToolTip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: paletteColors.sand.main,
    color: paletteColors.black.main,
    marginRight: "1rem",
    maxWidth: 380,
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "16px",
    fontFamily: "geograph-regular",
    padding: ".5rem 1rem",
  },
});

// export const UpdateHospitalToolTip =
// styled(({ className, ...props }: TooltipProps) => (
//   <Tooltip {...props} classes={{ popper: className }} />
// ))(() => ({
//   [`& .${tooltipClasses.tooltip}`]: {
//     backgroundColor: "#F9EED5",
//     color: "#262626",
//     maxWidth: 2000,
//     textAlign: "center",
//     fontSize: "0.8rem",
//     fontWeight: "400",
//     lineHeight: "16px",
//     fontFamily: "geograph-regular",
//     padding: ".3rem 1rem",
//     border: "1px solid #F7DC8D",
//   },
// }));

export const hospitalListStyle = (theme: Theme)=> ({
  "flexGrow": 1,
  ".info": {
    "padding": "24px",
    "background": "white",
    "*": {
      fontFamily: "geograph-regular",
    },
    "h1": {
      fontFamily: "grenette-light-pro",
      fontWeight: "600",
      fontSize: "20px",
    },
  },
  ".location-option": {
    "marginBottom": "1rem",
  },
  ".image-container": {
    "height": "200px",
    "cursor": "pointer",
    "width": "100%",
    "position": "relative",
    "> p": {
      "zIndex": 1,
      "opacity": 0,
      "position": "absolute",
      "top": "50%",
      "left": "50%",
      "transform": "translate(-50%,-50%)",
      "width": "100%",
      "height": "100%",
      "maxHeight": "200px",
      "display": "grid",
      "placeItems": "center",
      "color": "#FFF",
      "fontSize": "18px",
      "fontWeight": "500",
      "background":
   "linear-gradient(0deg, rgba(0, 0, 0, 0.32), rgba(0, 0, 0, 0.32))",
      "transition": ".3s all",
    },
  },

  ".image-container:hover": {
    "> p": {
      opacity: 1,
    },
  },
  "overflowY": "scroll", "height": "16rem",
  "&::-webkit-scrollbar": {
    width: 0,
  },
  "scrollBehavior": "smooth",
});


